(function(){
  'use strict';

  var ICON_SEARCH = '<svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"11\" cy=\"11\" r=\"8\"></circle><path d=\"m21 21-4.3-4.3\"></path></svg>';
  var ICON_X = '<svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 6 6 18\"></path><path d=\"m6 6 12 12\"></path></svg>';
  var ICON_XS = '<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 6 6 18\"></path><path d=\"m6 6 12 12\"></path></svg>';

  var old = document.querySelector('[data-muah-search-overlay]');
  if (old) { old.parentNode.removeChild(old); }

  var css = `
  .muah-sdrawer{position:fixed;inset:0;z-index:1200;}
  .muah-sdrawer[hidden]{display:none;}
  .muah-sdrawer__backdrop{position:absolute;inset:0;background:transparent;}
  .muah-sdrawer__panel{position:absolute;top:0;right:0;bottom:0;width:min(460px,100%);background:var(--color-bg,#fff);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .32s cubic-bezier(.32,.72,0,1);border-left:1px solid var(--color-border,rgba(0,0,0,.10));}
  .muah-sdrawer.is-open .muah-sdrawer__panel{transform:translateX(0);}
  .muah-sdrawer__head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 10px;}
  .muah-sdrawer__title{font-family:var(--font-body);font-size:13px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--color-fg,#2a1a15);}
  .muah-sdrawer__close{display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;margin-right:-8px;border:0;background:transparent;color:var(--color-fg,#2a1a15);border-radius:999px;cursor:pointer;transition:background .15s ease;}
  .muah-sdrawer__close:hover{background:var(--color-bg-soft,rgba(0,0,0,.05));}
  .muah-sdrawer__bar{display:flex;align-items:center;gap:6px;margin:0 20px;padding:8px 0 12px;border-bottom:2px solid var(--color-border,rgba(0,0,0,.12));}
  .muah-sdrawer__bar-icon{display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;margin-right:-8px;flex:0 0 auto;color:var(--color-fg-muted,#8a7c74);}
  .muah-sdrawer__input{flex:1;min-width:0;border:0;-webkit-appearance:none;appearance:none;border-radius:0;background:transparent;font-family:var(--font-body);font-size:16px;font-weight:400;color:var(--color-fg,#2a1a15);padding:4px 0;}
  .muah-sdrawer__input:focus,.muah-sdrawer__input:focus-visible{outline:none;box-shadow:none;border:0;}
  .muah-sdrawer__input::placeholder{font-size:16px;font-weight:400;color:var(--color-fg-muted,#9a8d85);}
  .muah-sdrawer__input::-webkit-search-cancel-button,.muah-sdrawer__input::-webkit-search-decoration{-webkit-appearance:none;appearance:none;}
  .muah-sdrawer__clear{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border:0;background:transparent;color:var(--color-fg-muted,#8a7c74);cursor:pointer;flex:0 0 auto;padding:0;transition:color .15s ease;}
  .muah-sdrawer__clear:hover{color:var(--color-fg,#2a1a15);}
  .muah-sdrawer__clear[hidden]{display:none;}
  .muah-sdrawer__results{flex:1;overflow-y:auto;padding:16px 20px 20px;position:relative;}
  .muah-sdrawer__results .muah-sresults__all{position:sticky;bottom:-4px;}
  body.muah-no-scroll{overflow:hidden;}`;
  var st = document.createElement('style');
  st.setAttribute('data-muah-search-css','');
  st.textContent = css;
  document.head.appendChild(st);

  var T = window.MUAH_T || {};
  var tx = function(k, d){ return (T[k] || d).replace(/"/g, '&quot;'); };
  var ROOT = window.MUAH_ROOT || '/';
  var drawer = document.createElement('div');
  drawer.className = 'muah-sdrawer';
  drawer.setAttribute('data-muah-sdrawer','');
  drawer.hidden = true;
  drawer.innerHTML =
    '<div class=\"muah-sdrawer__backdrop\" data-close></div>' +
    '<aside class=\"muah-sdrawer__panel\" role=\"dialog\" aria-modal=\"true\" aria-label=\"' + tx('search_title', 'Suche') + '\">' +
      '<div class=\"muah-sdrawer__head\">' +
        '<span class=\"muah-sdrawer__title\">' + tx('search_title', 'Suche') + '</span>' +
        '<button type=\"button\" class=\"muah-sdrawer__close\" data-close aria-label=\"' + tx('search_close', 'Suche schließen') + '\">' + ICON_X + '</button>' +
      '</div>' +
      '<form class=\"muah-sdrawer__bar\" action=\"' + ROOT + 'search\" method=\"get\" role=\"search\">' +
        '<input type=\"hidden\" name=\"type\" value=\"product\">' +
        '<input type=\"search\" name=\"q\" class=\"muah-sdrawer__input\" data-input placeholder=\"' + tx('search_placeholder', 'Was suchst du?') + '\" autocomplete=\"off\" aria-label=\"' + tx('search_term', 'Suchbegriff') + '\">' +
        '<button type=\"button\" class=\"muah-sdrawer__clear\" data-clear hidden aria-label=\"' + tx('search_clear', 'Eingabe löschen') + '\">' + ICON_XS + '</button>' +
        '<span class=\"muah-sdrawer__bar-icon\">' + ICON_SEARCH + '</span>' +
      '</form>' +
      '<div class=\"muah-sdrawer__results\" data-results></div>' +
    '</aside>';
  document.body.appendChild(drawer);

  var input   = drawer.querySelector('[data-input]');
  var results = drawer.querySelector('[data-results]');
  var clearBtn= drawer.querySelector('[data-clear]');
  var closeEls= drawer.querySelectorAll('[data-close]');

  function open(){
    drawer.hidden = false;
    void drawer.offsetHeight;
    drawer.classList.add('is-open');
    document.body.classList.add('muah-no-scroll');
    setTimeout(function(){ if(input){ input.focus(); } }, 80);
  }
  function close(){
    drawer.classList.remove('is-open');
    document.body.classList.remove('muah-no-scroll');
    setTimeout(function(){ drawer.hidden = true; }, 320);
  }

  document.addEventListener('muah:search:open', open);
  closeEls.forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  var timer = null;
  var lastQ = null;
  function doSearch(q){
    if(!q || q.length < 2){
      results.innerHTML = '';
      return;
    }
    if(q === lastQ) return;
    lastQ = q;
    fetch(ROOT + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=muah-search-results&resources[type]=product&resources[limit]=10', { headers: { 'Accept': 'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        if(input.value.trim() !== q) return;
        results.innerHTML = html;
        results.scrollTop = 0;
      })
      .catch(function(){});
  }

  if(input){
    input.addEventListener('input', function(){
      var v = input.value.trim();
      clearBtn.hidden = v.length === 0;
      clearTimeout(timer);
      timer = setTimeout(function(){ doSearch(v); }, 240);
    });
  }
  if(clearBtn){
    clearBtn.addEventListener('click', function(){
      input.value = '';
      clearBtn.hidden = true;
      lastQ = null;
      doSearch('');
      input.focus();
    });
  }
})();